// const URL = 'http://18.166.29.36'
// const URL = 'http://43.199.127.69'

const URL = 'https://spirnexs.com'

// const URL = 'http://localhost:9000'

const BASE_URL = `${URL}/api`
const BASE_URL_ALEXXCANSOLS = `${URL}/api/alexxcansols`

export const LOGIN_PATH = `${BASE_URL}/user/login`
export const REGISTER_PATH = `${BASE_URL}/user/register`
export const VERIFY_OTP = `${BASE_URL}/user/verify-otp`
export const RESET_PASSWORD = `${BASE_URL}/user/reset/password`
export const FORGOT_PASSWORD = `${BASE_URL}/user/resetpassword/mailsent`
export const VERIFY_MAIL = `${BASE_URL}/user/login/with/otp`
export const PROFILE_IMAGE = `${BASE_URL}/user/update/profile/image`
export const DELETE_PROFILE_IMAGE = (userId) => `${BASE_URL}/user/update/profile/image/${userId}`;

// alexxcansols API
export const CREATE_WISH = `${BASE_URL_ALEXXCANSOLS}/wish/create`;
export const WISH_LIST = `${BASE_URL_ALEXXCANSOLS}/wish/get`;
export const TOTAL_SUBSCRIPTION_LIST = `${BASE_URL_ALEXXCANSOLS}/report/total-subscription-list`;
export const TOTAL_SUBSCRIPTION_SUMMARY = `${BASE_URL_ALEXXCANSOLS}/report/total-subscription-summary`;

export const ENQUIRY_COMPANY_LIST = `${BASE_URL_ALEXXCANSOLS}/company/get`;
export const ENQUIRY_COMPANY_CREATE = `${BASE_URL_ALEXXCANSOLS}/company/create`;
export const ENQUIRY_COMPANY_VIEW = (clientCompanyId) => `${BASE_URL_ALEXXCANSOLS}/company/${clientCompanyId}`;
export const ENQUIRY_COMPANY_UPDATE = (clientCompanyId) => `${BASE_URL_ALEXXCANSOLS}/company/${clientCompanyId}`;
export const ENQUIRY_COMPANY_DELETE = (clientCompanyId) => `${BASE_URL_ALEXXCANSOLS}/company/${clientCompanyId}`;
export const ENQUIRY_COMPANY_BUTTON_LIST = `${BASE_URL_ALEXXCANSOLS}/company/button/get`;
export const ENQUIRY_COMPANY_RELATED_LIST = `${BASE_URL_ALEXXCANSOLS}/company/related-list`;
export const ENQUIRY_COMPANY_SEARCH = `${BASE_URL_ALEXXCANSOLS}/company/company-search`;

// 
export const ENQUIRY_COMPANY_USER_LIST = `${BASE_URL_ALEXXCANSOLS}/company/users/list`;
export const ENQUIRY_COMPANY_USER_CREATE = `${BASE_URL_ALEXXCANSOLS}/company/users/create`;
export const ENQUIRY_COMPANY_USER_VIEW = (enquiryUserId) => `${BASE_URL_ALEXXCANSOLS}/company/users/${enquiryUserId}`;
export const ENQUIRY_COMPANY_USER_UPDATE = (enquiryUserId) => `${BASE_URL_ALEXXCANSOLS}/company/users/${enquiryUserId}`;
export const ENQUIRY_COMPANY_USER_DELETE = (enquiryUserId) => `${BASE_URL_ALEXXCANSOLS}/company/users/${enquiryUserId}`;
export const ENQUIRY_COMPANY_USER_CONVERT_TO_USER = (enquiryUserId) => `${BASE_URL_ALEXXCANSOLS}/company/users/convert-to-user/${enquiryUserId}`;
export const PAYMENT_LINK_VERIFY_TOKEN = (token) => `${BASE_URL_ALEXXCANSOLS}/company/users/payment-link/verify/${token}`;
export const PAYMENT_LINK_GENERATE = `${BASE_URL_ALEXXCANSOLS}/company/users/payment-link/generate`;

export const ENQUIRY_SUBSCRIPTION_LIST = `${BASE_URL_ALEXXCANSOLS}/subscriptionlist/get`;
export const DELETED_USER_SUBSCRIPTION_LIST = `${BASE_URL_ALEXXCANSOLS}/subscriptionlist/deleted-users/list`;
export const ENQUIRY_SUBSCRIPTION_EXPIRY_REMINDER = `${BASE_URL_ALEXXCANSOLS}/subscriptionlist/expiry-remainder`;
export const ONBOARDING_SUBSCRIPTION_LIST = `${BASE_URL_ALEXXCANSOLS}/subscriptionlist/onboarding-subscription-list`;
export const SUBSCRIPTION_GRACE_REPORT = `${BASE_URL_ALEXXCANSOLS}/report/subscription-grace-report`;

export const DELETE_DATABASE_LOG_REPORT = `${BASE_URL_ALEXXCANSOLS}/report/delete-database-log`;
export const PARTNER_LIST_REPORT = `${BASE_URL_ALEXXCANSOLS}/report/partner-list-report`;

export const ENQUIRY_SUBSCRIPTION_PLAN = `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/get`;
export const ENQUIRY_SUBSCRIPTION_PLAN_ACTIVE = `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/active/get`;
export const ENQUIRY_SUBSCRIPTION_PLAN_CREATE = `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/create`;
export const ENQUIRY_SUBSCRIPTION_PLAN_UPDATE = (subscriptionPlanId) => `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/${subscriptionPlanId}`;
export const ENQUIRY_SUBSCRIPTION_PLAN_VIEW = (subscriptionPlanId) => `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/${subscriptionPlanId}`;
export const ENQUIRY_SUBSCRIPTION_PLAN_DELETE = (subscriptionPlanId) => `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/${subscriptionPlanId}`;
export const SUBSCRIPTION_LIST_PLAN_UPDATE = (subscriptionPlanId) => `${BASE_URL_ALEXXCANSOLS}/subscriptionplan/list/${subscriptionPlanId}`;

export const BLOG_CREATE = `${BASE_URL_ALEXXCANSOLS}/blog/create`;
export const BLOG_GET = `${BASE_URL_ALEXXCANSOLS}/blog/get`;
export const BLOG_UPDATE = (blogId) => `${BASE_URL_ALEXXCANSOLS}/blog/${blogId}`;
export const BLOG_DELETE = (blogId) => `${BASE_URL_ALEXXCANSOLS}/blog/${blogId}`;
export const BLOG_VIEW = (blogId) => `${BASE_URL_ALEXXCANSOLS}/blog/${blogId}`;
export const BLOG_PUBLIC = `${BASE_URL_ALEXXCANSOLS}/blog/public`;

// Case Study Endpointscase-studies 
export const CASE_STUDY_CREATE = `${BASE_URL_ALEXXCANSOLS}/case-studies/create`;
export const CASE_STUDY_GET = `${BASE_URL_ALEXXCANSOLS}/case-studies/get`;
export const CASE_STUDY_UPDATE = (caseStudyId) => `${BASE_URL_ALEXXCANSOLS}/case-studies/${caseStudyId}`;
export const CASE_STUDY_DELETE = (caseStudyId) => `${BASE_URL_ALEXXCANSOLS}/case-studies/${caseStudyId}`;
export const CASE_STUDY_VIEW = (caseStudyId) => `${BASE_URL_ALEXXCANSOLS}/case-studies/${caseStudyId}`;
export const CASE_STUDY_PUBLIC = `${BASE_URL_ALEXXCANSOLS}/case-studies/public`;


export const NEWS_CREATE = `${BASE_URL_ALEXXCANSOLS}/news/create`;
export const NEWS_GET = `${BASE_URL_ALEXXCANSOLS}/news/get`;
export const NEWS_UPDATE = (newsId) => `${BASE_URL_ALEXXCANSOLS}/news/${newsId}`;
export const NEWS_DELETE = (newsId) => `${BASE_URL_ALEXXCANSOLS}/news/${newsId}`;
export const NEWS_VIEW = (newsId) => `${BASE_URL_ALEXXCANSOLS}/news/${newsId}`;
export const NEWS_PUBLIC = `${BASE_URL_ALEXXCANSOLS}/news/public`;


// ENQUIRY LEAD ENDPOINTS
export const ENQUIRY_LEAD_LIST = `${BASE_URL_ALEXXCANSOLS}/leads/get`;
export const ENQUIRY_LEAD_CREATE = `${BASE_URL_ALEXXCANSOLS}/leads/create`;
export const ENQUIRY_LEAD_VIEW = (leadId) => `${BASE_URL_ALEXXCANSOLS}/leads/${leadId}`;
export const ENQUIRY_LEAD_UPDATE = (leadId) => `${BASE_URL_ALEXXCANSOLS}/leads/${leadId}`;
export const ENQUIRY_LEAD_DELETE = (leadId) => `${BASE_URL_ALEXXCANSOLS}/leads/${leadId}`;
export const ENQUIRY_LEAD_CONVERT_TO_USER_ONBOARDING = (leadId) => `${BASE_URL_ALEXXCANSOLS}/leads/convert-enquiry-to-user-onboarding/${leadId}`;

// ENQUIRY CONTACT ENDPOINTS
export const ENQUIRY_CONTACT_LIST = `${BASE_URL_ALEXXCANSOLS}/contact/get`;
export const ENQUIRY_CONTACT_CREATE = `${BASE_URL_ALEXXCANSOLS}/contact/create`;
export const ENQUIRY_CONTACT_VIEW = (contactId) => `${BASE_URL_ALEXXCANSOLS}/contact/${contactId}`;
export const ENQUIRY_CONTACT_UPDATE = (contactId) => `${BASE_URL_ALEXXCANSOLS}/contact/${contactId}`;
export const ENQUIRY_CONTACT_DELETE = (contactId) => `${BASE_URL_ALEXXCANSOLS}/contact/${contactId}`;

// Company image
export const COMPANY_LOGO = `${BASE_URL}/company/company-logo`;
export const COMPANY_FOOTER = `${BASE_URL}/company/company-footer`;
export const COMPANY_SIGN_STAMP = `${BASE_URL}/company/company-sign-stamp`;
export const GET_COMPANY_ASSIGN_LIST = `${BASE_URL}/company/assign-list`;

// Export shipment all data import/export invice pdf/print
export const GET_INVOICE_EXPORT_PROFORMA_INVOICE = `${BASE_URL}/invoice/export-proforma-invoice`;
export const GET_IMPORT_INVOICE = `${BASE_URL}/invoice/import-invoice`;


// company bank detail
export const CREATE_COMPANY_BANK = `${BASE_URL}/company-bank/create`;
export const GET_COMPANY_BANKS = `${BASE_URL}/company-bank/get`;
export const READ_COMPANY_BANK = (companyBankId) => `${BASE_URL}/company-bank/${companyBankId}`;
export const UPDATE_COMPANY_BANK = (companyBankId) => `${BASE_URL}/company-bank/${companyBankId}`;
export const DELETE_COMPANY_BANK = (companyBankId) => `${BASE_URL}/company-bank/${companyBankId}`;
export const UPDATE_COMPANY_BANK_STATUS = (companyBankId) => `${BASE_URL}/company-bank/status/${companyBankId}`;


//common 
export const BUSINESS_GROUP = `${BASE_URL}/common/business-groups`
export const CREATE_BUSINESS_GROUP = `${BASE_URL}/common/business-groups-create`
export const GET_DOCUMENT_NAME_LIST = `${BASE_URL}/common/document-name-list`
export const UPDATE_BUSINESS_GROUP = (businessGroupId) => `${BASE_URL}/common/business-groups/${businessGroupId}`;
export const READ_BUSINESS_GROUP = (businessGroupId) => `${BASE_URL}/common/business-groups/${businessGroupId}`;
export const DELETE_BUSINESS_GROUP = (businessGroupId) => `${BASE_URL}/common/business-groups/${businessGroupId}`;

export const BLOG_STATUS_LIST = `${BASE_URL}/common/blog-status-list`;
export const BLOG_CATEGORY_LIST = `${BASE_URL}/common/blog-category-list`;


export const INDUSTRY_TYPE = `${BASE_URL}/common/industry-types`
export const LEAD_SOURCE = `${BASE_URL}/common/lead-sources`
export const CREATE_LEAD_SOURCE = `${BASE_URL}/common/lead-sources-create`
export const UPDATE_LEAD_SOURCE = (leadSourceId) => `${BASE_URL}/common/lead-sources/${leadSourceId}`;
export const PAYMENT_METHOD = `${BASE_URL}/common/payment-method`
export const LEAD_STATUSES = `${BASE_URL}/common/lead-statuses`
export const CREATE_LEAD_STATUSES = `${BASE_URL}/common/lead-statuses-create`
export const UPDATE_LEAD_STATUSES = (leadStatusId) => `${BASE_URL}/common/lead-statuses/${leadStatusId}`;
export const GET_COLOR_PLATE = `${BASE_URL}/common/color-plate`
export const GET_RATING = `${BASE_URL}/common/ratings`
export const CREATE_RATING = `${BASE_URL}/common/ratings-create`
export const UPDATE_RATING = (ratingId) => `${BASE_URL}/common/ratings/${ratingId}`;

export const GET_COMPANIES = `${BASE_URL}/common/companies`
export const GET_COUNTRIES = `${BASE_URL}/common/countries`
export const GET_STATES = `${BASE_URL}/common/countries`
export const GET_CITY = `${BASE_URL}/common/states`
export const GET_TITLES = `${BASE_URL}/common/titles`
export const GET_CALL_TYPE = `${BASE_URL}/common/call-type`
export const GET_PAYMENT_AGAINST = `${BASE_URL}/common/payment-against`

export const GET_COMPANY_TYPES = `${BASE_URL}/common/company-types`
export const GET_COMPANY_OWNERSHIP_TYPES = `${BASE_URL}/common/ownership-types`
export const GET_CALL_PURPOSE_TYPES = `${BASE_URL}/common/call-purpose-types`
export const GET_CALL_OUTCOME_TYPES = `${BASE_URL}/common/call-outcome-types`
export const GET_PRIORITIES_LOSS_REASONS = `${BASE_URL}/common/loss-reasons`
export const CREATE_PRIORITIES_LOSS_REASONS = `${BASE_URL}/common/loss-reasons-create`
export const UPDATE_PRIORITIES_LOSS_REASONS = (lossReasonId) => `${BASE_URL}/common/loss-reasons/${lossReasonId}`;
export const READ_PRIORITIES_LOSS_REASONS = (lossReasonId) => `${BASE_URL}/common/loss-reasons/${lossReasonId}`;
export const DELETE_PRIORITIES_LOSS_REASONS = (lossReasonId) => `${BASE_URL}/common/loss-reasons/${lossReasonId}`;


export const GET_COMPANY_MODULES = `${BASE_URL}/common/company-modules`
export const GET_CONTACT_DEPARTMENTS = `${BASE_URL}/common/contact-departments`
export const GET_CONTACT_GROUPS = `${BASE_URL}/common/contact-groups`
export const CREATE_CONTACT_GROUPS = `${BASE_URL}/common/contact-groups-create`
export const UPDATE_CONTACT_GROUPS = (contactGroupId) => `${BASE_URL}/common/contact-groups/${contactGroupId}`;
export const READ_CONTACT_GROUPS = (contactGroupId) => `${BASE_URL}/common/contact-groups/${contactGroupId}`;
export const DELETE_CONTACT_GROUPS = (contactGroupId) => `${BASE_URL}/common/contact-groups/${contactGroupId}`;


export const GET_CONTACT_TYPES = `${BASE_URL}/common/contact-types`
export const CREATE_CONTACT_TYPES = `${BASE_URL}/common/contact-types-create`
export const UPDATE_CONTACT_TYPES = (contactTypeId) => `${BASE_URL}/common/contact-types/${contactTypeId}`;
export const READ_CONTACT_TYPES = (contactTypeId) => `${BASE_URL}/common/contact-types/${contactTypeId}`;
export const DELETE_CONTACT_TYPES = (contactTypeId) => `${BASE_URL}/common/contact-types/${contactTypeId}`;

export const GET_MODULES = `${BASE_URL}/common/modules`
export const GET_TASK_STATUSES = `${BASE_URL}/common/task-statuses`
export const CREATE_TASK_STATUSES = `${BASE_URL}/common/task-statuses-create`
export const UPDATE_TASK_STATUSES = (taskStatusId) => `${BASE_URL}/common/task-statuses/${taskStatusId}`;
export const READ_TASK_STATUSES = (taskStatusId) => `${BASE_URL}/common/task-statuses/${taskStatusId}`;
export const DELETE_TASK_STATUSES = (taskStatusId) => `${BASE_URL}/common/task-statuses/${taskStatusId}`;


export const GET_LEAD_STAGES = `${BASE_URL}/common/lead-stages`
export const GET_PRIORITIES = `${BASE_URL}/common/priorities`
export const CREATE_PRIORITIES = `${BASE_URL}/common/priorities-create`
export const UPDATE_PRIORITIES = (priorityId) => `${BASE_URL}/common/priorities/${priorityId}`;
export const READ_PRIORITIES = (priorityId) => `${BASE_URL}/common/priorities/${priorityId}`;
export const DELETE_PRIORITIES = (priorityId) => `${BASE_URL}/common/priorities/${priorityId}`;


export const GET_CIF_FOB_LIST = `${BASE_URL}/common/cif-fob-list`;
export const GET_SHIPMENT_TYPES = `${BASE_URL}/common/shipment-types`;
export const GET_CURRENCY_LIST = `${BASE_URL}/common/currency-list`;
export const GET_COMPANY_CURRENCY_LIST = `${BASE_URL}/common/company-currency-list`;
export const GET_SUPPLIERS_LIST = `${BASE_URL}/common/suppliers-list`;
export const GET_PRODUCTS_LIST = `${BASE_URL}/common/products-list`;
export const CREATE_PRODUCTS_LIST = `${BASE_URL}/common/products-list/create`;
export const UPDATE_PRODUCTS_LIST = (productsId) => `${BASE_URL}/common/products-list/${productsId}`;
export const READ_PRODUCTS_LIST = (productsId) => `${BASE_URL}/common/products-list/${productsId}`;
export const DELETE_PRODUCTS_LIST = (productsId) => `${BASE_URL}/common/products-list/${productsId}`;


export const GET_CONTACT_PERSON_LIST = `${BASE_URL}/common/contact-person-list`;
export const GET_ALEXXCANSOLS_CONTACT_PERSON_LIST = `${BASE_URL}/common/alexxcansols/contact-person-list`;
export const GET_LEAD_OWNER = `${BASE_URL}/common/lead-owner`;
export const GET_SHIPPING_LINE = `${BASE_URL}/common/shipping-line`;
export const CREATE_SHIPPING_LINE = `${BASE_URL}/common/shipping-line-create`;
export const GET_FCL_LIST = `${BASE_URL}/common/fcl-list`;
export const GET_DIRECT_LIST = `${BASE_URL}/common/direct-list`;
export const GET_FREIGHT_FORWARD_AGENCY_LIST = `${BASE_URL}/common/freight-forward-agency-list`;
export const CREATE_FREIGHT_FORWARD_AGENCY = `${BASE_URL}/common/freight-forward-agency-create`;
export const GET_CUSTOM_CLEARING_AGENCY_LIST = `${BASE_URL}/common/custom-clearing-agency-list`;
export const CREATE_CUSTOM_CLEARING_AGENCY = `${BASE_URL}/common/custom-clearing-agency-create`;
export const GET_PAYMENT_TYPE_LIST = `${BASE_URL}/common/payment-type-list`;
export const GET_RECEIPT_TYPE_LIST = `${BASE_URL}/common/receipt-type-list`;
export const GET_EXPENSE_LEDGER_LIST = `${BASE_URL}/common/expense-ledger-list`;
export const CREATE_EXPENSE_LEDGER = `${BASE_URL}/common/expense-ledger-create`;
export const READ_EXPENSE_LEDGER = (expenseLedgerId) => `${BASE_URL}/common/expense-ledger/${expenseLedgerId}`;
export const UPDATE_EXPENSE_LEDGER = (expenseLedgerId) => `${BASE_URL}/common/expense-ledger/${expenseLedgerId}`;
export const DELETE_EXPENSE_LEDGER = (expenseLedgerId) => `${BASE_URL}/common/expense-ledger/${expenseLedgerId}`;
export const READ_SHIPPING_LINE = (shippingLineId) => `${BASE_URL}/common/shipping-line/${shippingLineId}`;
export const UPDATE_SHIPPING_LINE = (shippingLineId) => `${BASE_URL}/common/shipping-line/${shippingLineId}`;
export const DELETE_SHIPPING_LINE = (shippingLineId) => `${BASE_URL}/common/shipping-line/${shippingLineId}`;
export const READ_FREIGHT_FORWARD_AGENCY = (agencyId) => `${BASE_URL}/common/freight-forward-agency/${agencyId}`;
export const UPDATE_FREIGHT_FORWARD_AGENCY = (agencyId) => `${BASE_URL}/common/freight-forward-agency/${agencyId}`;
export const DELETE_FREIGHT_FORWARD_AGENCY = (agencyId) => `${BASE_URL}/common/freight-forward-agency/${agencyId}`;
export const READ_CUSTOM_CLEARING_AGENCY = (chaId) => `${BASE_URL}/common/custom-clearing-agency/${chaId}`;
export const UPDATE_CUSTOM_CLEARING_AGENCY = (chaId) => `${BASE_URL}/common/custom-clearing-agency/${chaId}`;
export const DELETE_CUSTOM_CLEARING_AGENCY = (chaId) => `${BASE_URL}/common/custom-clearing-agency/${chaId}`;
export const GET_Financial_Year = `${BASE_URL}/common/financial-year`;
export const GET_FREFIX_SUFFIX = `${BASE_URL}/common/frefix-suffix`;
export const GET_SHIPPING_STATUS = `${BASE_URL}/common/shipping-status`;
export const GET_UNIT_LIST = `${BASE_URL}/common/unit-list`;
export const CREATE_UNIT_LIST = `${BASE_URL}/common/unit-list`;
export const READ_UNIT_LIST = (productsUnitId) => `${BASE_URL}/common/unit-list/${productsUnitId}`;
export const UPDATE_UNIT_LIST = (productsUnitId) => `${BASE_URL}/common/unit-list/${productsUnitId}`;
export const DELETE_UNIT_lIST = (productsUnitId) => `${BASE_URL}/common/unit-list/${productsUnitId}`;
export const GET_UNIT_QUALITY_CODE = `${BASE_URL}/common/unit-quality-code`;
export const GET_VOUCHER = `${BASE_URL}/common/voucher`;
export const GET_TERM_CONDITIONS = `${BASE_URL}/common/term-conditios`;
export const CREATE_TERM_CONDITIONS = `${BASE_URL}/common/term-conditios-create`;
export const READ_TERM_CONDITIONS = (id) => `${BASE_URL}/common/term-conditios/${id}`;
export const DELETE_TERM_CONDITIONS = (id) => `${BASE_URL}/common/term-conditios/${id}`;
export const UPDATE_TERM_CONDITIONS = (id) => `${BASE_URL}/common/term-conditios/${id}`;

export const CREATE_PRODUCTS_GROUP = `${BASE_URL}/common/products-group-create`;
export const GET_PRODUCTS_GROUP = `${BASE_URL}/common/products-group-list`;
export const READ_PRODUCTS_GROUP = (productsGroupId) => `${BASE_URL}/common/products-group/${productsGroupId}`;
export const UPDATE_PRODUCTS_GROUP = (productsGroupId) => `${BASE_URL}/common/products-group/${productsGroupId}`;
export const DELETE_PRODUCTS_GROUP = (productsGroupId) => `${BASE_URL}/common/products-group/${productsGroupId}`;

export const CREATE_PORT_MASTERS = `${BASE_URL}/common/port-masters-create`;
export const GET_PORT_MASTERS = `${BASE_URL}/common/port-masters-list`;
export const READ_PORT_MASTERS = (portMastersId) => `${BASE_URL}/common/port-masters-list/${portMastersId}`;
export const UPDATE_PORT_MASTERS = (portMastersId) => `${BASE_URL}/common/port-masters-list/${portMastersId}`;
export const DELETE_PORT_MASTERS = (portMastersId) => `${BASE_URL}/common/port-masters-list/${portMastersId}`;

// Party Ledger API Endpoints
export const CREATE_PARTY_LEDGER = `${BASE_URL}/common/party-ledger-create`;
export const GET_PARTY_LEDGER_LIST = `${BASE_URL}/common/party-ledger-list`;
export const READ_PARTY_LEDGER = (partyLedgerId) => `${BASE_URL}/common/party-ledger/${partyLedgerId}`;
export const UPDATE_PARTY_LEDGER = (partyLedgerId) => `${BASE_URL}/common/party-ledger/${partyLedgerId}`;
export const DELETE_PARTY_LEDGER = (partyLedgerId) => `${BASE_URL}/common/party-ledger/${partyLedgerId}`;

export const GET_PAYMENT_TO_LIST = `${BASE_URL}/common/payment-to-list`;


// Lead API
export const GET_LEADS = `${BASE_URL}/leads/get`
export const Creact_LEADS = `${BASE_URL}/leads/create`
export const GET_Lead_leadId = (leadId) => `${BASE_URL}/leads/${leadId}`;
export const Update_Lead_leadId = (leadId) => `${BASE_URL}/leads/${leadId}`;
export const Delete_Lead_leadId = (leadId) => `${BASE_URL}/leads/${leadId}`;
export const GET_LEAD_RELATED_LIST = `${BASE_URL}/leads/related-list`
// Company API
export const CreateMyCompany = `${BASE_URL}/company/create`
export const GET_COMPANY = `${BASE_URL}/company/get`
export const GET_COMPANY_id = (id) => `${BASE_URL}/company/${id}`;
export const UPDATE_COMPANY = (companyId) => `${BASE_URL}/company/${companyId}`;
export const SET_DEFAULT_COMPANY = `${BASE_URL}/company/set/default`;
export const UPDATE_COMPANY_DETAIL = (companyId) => `${BASE_URL}/company/detail/${companyId}`;
export const DELETE_COMPANY_ID = (companyId) => `${BASE_URL}/company/${companyId}`;
export const UPDATE_COMPANY_TEMPLATE = (companyId) => `${BASE_URL}/company/company-template/${companyId}`;

// contact API
export const GET_contact = `${BASE_URL}/contact/get`
export const Create_contact = `${BASE_URL}/contact/create`
export const GET_contactId = (contactId) => `${BASE_URL}/contact/${contactId}`;
export const Delete_Contact_contactId = (contactId) => `${BASE_URL}/contact/${contactId}`;
export const Update_contacts = (contactId) => `${BASE_URL}/contact/${contactId}`;


// client company API
export const GET_clientCompanies = `${BASE_URL}/client-company/get`
export const Delete_clientCompanies = (clientCompanyId) => `${BASE_URL}/client-company/${clientCompanyId}`;
export const Create_clientCompanies = `${BASE_URL}/client-company/create`
export const Update_clientCompanyId = (clientCompanyId) => `${BASE_URL}/client-company/${clientCompanyId}`;
export const GET_clientCompany_Id = (clientCompanyId) => `${BASE_URL}/client-company/${clientCompanyId}`;
export const SEARCH_CLIENT_COMPANY = `${BASE_URL}/client-company/company-search`


// client company  Tax API
export const GET_clientCompanies_tax = `${BASE_URL}/client-company/tax/get`
export const Delete_clientCompanies_tax = (companyTaxId) => `${BASE_URL}/client-company/tax/${companyTaxId}`;
export const Create_clientCompanies_tax = `${BASE_URL}/client-company/tax/create`
export const Update_clientCompany_tax = (companyTaxId) => `${BASE_URL}/client-company/tax/${companyTaxId}`;
export const GET_clientCompany_tax = (companyTaxId) => `${BASE_URL}/client-company/tax/${companyTaxId}`;
export const GET_clientCompany_TaxId = (clientCompanyId) => `${BASE_URL}/client-company/tax/client/${clientCompanyId}`;
export const CLIENT_COMPANY_BUTTON_LIST = `${BASE_URL}/client-company/button/get`;
export const CLIENT_COMPANY_RELATED_LIST = `${BASE_URL}/client-company/related-list`;


// calls
export const GET_call = `${BASE_URL}/call/get`
export const GET_call_LIST = `${BASE_URL}/call/list`
export const Create_call = `${BASE_URL}/call/create`
export const GET_call_id = (callId) => `${BASE_URL}/call/${callId}`;
export const Update_call_id = (callId) => `${BASE_URL}/call/${callId}`;
export const Delete_call_id = (callId) => `${BASE_URL}/call/${callId}`;

// Tasks
export const GET_task = `${BASE_URL}/task/get`
export const GET_task_LIST = `${BASE_URL}/task/list`
export const Create_task = `${BASE_URL}/task/create`
export const Get_task_taskId = (taskId) => `${BASE_URL}/task/${taskId}`;
export const Update_task = (taskId) => `${BASE_URL}/task/${taskId}`;
export const Delete_task = (taskId) => `${BASE_URL}/task/${taskId}`;
// note
export const GET_NOTES_LIST = `${BASE_URL}/notes/list`;
export const CREATE_NOTES = `${BASE_URL}/notes/create`;
export const GET_NOTES_ID = (notesId) => `${BASE_URL}/notes/${notesId}`;
export const UPDATE_NOTES = (notesId) => `${BASE_URL}/notes/${notesId}`;
export const DELETE_NOTES = (notesId) => `${BASE_URL}/notes/${notesId}`;
// Order Planning
export const LIST_ALL_ORDER_PLANNING = `${BASE_URL}/order-planning/get`;
export const CREATE_ORDER_PLANNING = `${BASE_URL}/order-planning/create`;
export const UPDATE_ORDER_PLANNING = (orderPlanningId) => `${BASE_URL}/order-planning/${orderPlanningId}`;
export const ORDER_PLANNING_ASSIGN_SHIPMENT = (orderPlanningId) => `${BASE_URL}/order-planning/assign-shipment/${orderPlanningId}`;
export const DELETE_ORDER_PLANNING = (orderPlanningId) => `${BASE_URL}/order-planning/${orderPlanningId}`;
export const READ_ORDER_PLANNING = (orderPlanningId) => `${BASE_URL}/order-planning/${orderPlanningId}`;
export const DELETE_ORDER_PLANNING_PARTICULAR = (orderParticularsId) => `${BASE_URL}/order-planning/particular/${orderParticularsId}`;

// Import Shipment  
export const CREATE_IMPORT_SHIPMENT = `${BASE_URL}/import-shipment/create`;
export const UPDATE_IMPORT_SHIPMENT = (importShipmentId) => `${BASE_URL}/import-shipment/${importShipmentId}`;
export const DELETE_IMPORT_SHIPMENT = (importShipmentId) => `${BASE_URL}/import-shipment/${importShipmentId}`;
export const READ_IMPORT_SHIPMENT = (importShipmentId) => `${BASE_URL}/import-shipment/${importShipmentId}`;
export const LIST_ALL_IMPORT_SHIPMENT = `${BASE_URL}/import-shipment/get`;
export const IMPORT_SHIPMENT_BUTTON_LIST = `${BASE_URL}/import-shipment/button/get`;
export const IMPORT_SHIPMENT_RELATED_LIST = `${BASE_URL}/import-shipment/related-list`;
export const IMPORT_SHIPMENT_COMPARE = `${BASE_URL}/import-shipment/compare/get`;


// Export shipment
export const CREATE_EXPORT_SHIPMENT = `${BASE_URL}/export-shipment/create`;
export const UPDATE_EXPORT_SHIPMENT = (exportShipmentId) => `${BASE_URL}/export-shipment/${exportShipmentId}`;
export const DELETE_EXPORT_SHIPMENT = (exportShipmentId) => `${BASE_URL}/export-shipment/${exportShipmentId}`;
export const READ_EXPORT_SHIPMENT = (exportShipmentId) => `${BASE_URL}/export-shipment/${exportShipmentId}`;
export const LIST_ALL_EXPORT_SHIPMENT = `${BASE_URL}/export-shipment/get`;
export const EXPORT_SHIPMENT_BUTTON_LIST = `${BASE_URL}/export-shipment/button/get`;
export const EXPORT_SHIPMENT_RELATED_LIST = `${BASE_URL}/export-shipment/related-list`;
export const EXPORT_SHIPMENT_COMPARE = `${BASE_URL}/export-shipment/compare/get`;

// Import Shipping Mark
export const CREATE_IMPORT_SHIPPING_MARK = `${BASE_URL}/import-shipment/shipping-marks/create`;
export const LIST_IMPORT_SHIPPING_MARKS = `${BASE_URL}/import-shipment/shipping-marks/get`;
export const READ_IMPORT_SHIPPING_MARK = (shippingMarkId) => `${BASE_URL}/import-shipment/shipping-marks/${shippingMarkId}`;
export const DELETE_IMPORT_SHIPPING_MARK = (shippingMarkId) => `${BASE_URL}/import-shipment/shipping-marks/${shippingMarkId}`;
export const UPDATE_IMPORT_SHIPPING_MARK = (shippingMarkId) => `${BASE_URL}/import-shipment/shipping-marks/${shippingMarkId}`;

// Import shipping tracker
export const CREATE_SHIPPING_TRACKER = `${BASE_URL}/import-shipment/shipping-tracker/create`;
export const LIST_SHIPPING_TRACKER = `${BASE_URL}/import-shipment/shipping-tracker/get`;



// Import Payment Voucher
export const CREATE_IMPORT_PAYMENT_VOUCHER = `${BASE_URL}/import-shipment/payment-voucher/create`;
export const LIST_IMPORT_PAYMENT_VOUCHERS = `${BASE_URL}/import-shipment/payment-voucher/get`;
export const READ_IMPORT_PAYMENT_VOUCHER = (paymentVoucherId) => `${BASE_URL}/import-shipment/payment-voucher/${paymentVoucherId}`;
export const DELETE_IMPORT_PAYMENT_VOUCHER = (paymentVoucherId) => `${BASE_URL}/import-shipment/payment-voucher/${paymentVoucherId}`;
export const UPDATE_IMPORT_PAYMENT_VOUCHER = (paymentVoucherId) => `${BASE_URL}/import-shipment/payment-voucher/${paymentVoucherId}`;
export const DELETE_IMPORT_PAYMENT_VOUCHER_PARTICULAR = (paymentVoucherParticularsId) => `${BASE_URL}/import-shipment/payment-voucher-particular/${paymentVoucherParticularsId}`;

//Import Expense Voucher
export const CREATE_EXPENSE_VOUCHER = `${BASE_URL}/import-shipment/expense-voucher/create`;
export const LIST_EXPENSE_VOUCHERS = `${BASE_URL}/import-shipment/expense-voucher/get`;
export const READ_EXPENSE_VOUCHER = (ExpenseVoucherId) => `${BASE_URL}/import-shipment/expense-voucher/${ExpenseVoucherId}`;
export const DELETE_EXPENSE_VOUCHER = (ExpenseVoucherId) => `${BASE_URL}/import-shipment/expense-voucher/${ExpenseVoucherId}`;
export const UPDATE_EXPENSE_VOUCHER = (ExpenseVoucherId) => `${BASE_URL}/import-shipment/expense-voucher/${ExpenseVoucherId}`;

// Import Shipping Booking
export const CREATE_IMPORT_SHIPPING_BOOKING = `${BASE_URL}/import-shipment/shipping-booking/create`;
export const LIST_IMPORT_SHIPPING_BOOKINGS = `${BASE_URL}/import-shipment/shipping-booking/get`;
export const READ_IMPORT_SHIPPING_BOOKING = (shippingBookingId) => `${BASE_URL}/import-shipment/shipping-booking/${shippingBookingId}`;
export const DELETE_IMPORT_SHIPPING_BOOKING = (shippingBookingId) => `${BASE_URL}/import-shipment/shipping-booking/${shippingBookingId}`;
export const UPDATE_IMPORT_SHIPPING_BOOKING = (shippingBookingId) => `${BASE_URL}/import-shipment/shipping-booking/${shippingBookingId}`;

// Import Planning Budget
export const CREATE_IMPORT_PLANNING_BUDGET = `${BASE_URL}/import-shipment/planning-budget/create`;
export const LIST_IMPORT_PLANNING_BUDGETS = `${BASE_URL}/import-shipment/planning-budget/get`;
export const READ_IMPORT_PLANNING_BUDGET = (planningBudgetId) => `${BASE_URL}/import-shipment/planning-budget/${planningBudgetId}`;
export const DELETE_IMPORT_PLANNING_BUDGET = (planningBudgetId) => `${BASE_URL}/import-shipment/planning-budget/${planningBudgetId}`;
export const UPDATE_IMPORT_PLANNING_BUDGET = (planningBudgetId) => `${BASE_URL}/import-shipment/planning-budget/${planningBudgetId}`;


//Import Proforma Invoice
export const LIST_PROFORMA_INVOICES = `${BASE_URL}/import-shipment/proforma-invoice/get`;
export const CREATE_PROFORMA_INVOICE = `${BASE_URL}/import-shipment/proforma-invoice/create`;
export const READ_PROFORMA_INVOICE = (proformaInvoiceId) => `${BASE_URL}/import-shipment/proforma-invoice/${proformaInvoiceId}`;
export const UPDATE_PROFORMA_INVOICE = (proformaInvoiceId) => `${BASE_URL}/import-shipment/proforma-invoice/${proformaInvoiceId}`;
export const DELETE_PROFORMA_INVOICE = (proformaInvoiceId) => `${BASE_URL}/import-shipment/proforma-invoice/${proformaInvoiceId}`;
export const DELETE_PROFORMA_INVOICE_PARTICULAR = (proformaInvoiceParticularId) => `${BASE_URL}/import-shipment/proforma-invoice-particular/${proformaInvoiceParticularId}`;
export const CREATE_PROFORMA_INVOICE_UPLOAD = `${BASE_URL}/import-shipment/proforma-invoice/-upload`;


// Import Commercial Invoice
export const LIST_COMMERCIAL_INVOICES = `${BASE_URL}/import-shipment/commercial-invoice/get`;
export const CREATE_COMMERCIAL_INVOICE = `${BASE_URL}/import-shipment/commercial-invoice/create`;
export const READ_COMMERCIAL_INVOICE = (commercialInvoiceId) => `${BASE_URL}/import-shipment/commercial-invoice/${commercialInvoiceId}`;
export const UPDATE_COMMERCIAL_INVOICE = (commercialInvoiceId) => `${BASE_URL}/import-shipment/commercial-invoice/${commercialInvoiceId}`;
export const DELETE_COMMERCIAL_INVOICE = (commercialInvoiceId) => `${BASE_URL}/import-shipment/commercial-invoice/${commercialInvoiceId}`;
export const DELETE_COMMERCIAL_INVOICE_PARTICULAR = (commercialInvoiceParticularId) => `${BASE_URL}/import-shipment/commercial-invoice-particular/${commercialInvoiceParticularId}`;

// Import Purchase Orders
export const LIST_PURCHASE_ORDERS = `${BASE_URL}/import-shipment/purchase-orders/get`;
export const CREATE_PURCHASE_ORDER = `${BASE_URL}/import-shipment/purchase-orders/create`;
export const READ_PURCHASE_ORDER = (purchaseOrderId) => `${BASE_URL}/import-shipment/purchase-orders/${purchaseOrderId}`;
export const UPDATE_PURCHASE_ORDER = (purchaseOrderId) => `${BASE_URL}/import-shipment/purchase-orders/${purchaseOrderId}`;
export const DELETE_PURCHASE_ORDER = (purchaseOrderId) => `${BASE_URL}/import-shipment/purchase-orders/${purchaseOrderId}`;
export const DELETE_PURCHASE_ORDER_PARTICULAR = (purchaseOrderParticularsId) => `${BASE_URL}/import-shipment/purchase-orders-particular/${purchaseOrderParticularsId}`;

// Import document
export const LIST_ATTATCH_DOCUMENTS = `${BASE_URL}/import-shipment/attatch-documents/get`;
export const CREATE_ATTATCH_DOCUMENTS = `${BASE_URL}/import-shipment/attatch-documents/create`;
export const DELETE_ATTATCH_DOCUMENTS = (attatchDocumentId) => `${BASE_URL}/import-shipment/attatch-documents/${attatchDocumentId}`;
export const LIST_ATTATCH_DOCUMENTS_BL_LIST = `${BASE_URL}/import-shipment/attatch-documents/bl-list`;


export const CREATE_LOADING_PHOTO = `${BASE_URL}/import-shipment/loading-photos/create`;
export const LIST_LOADING_PHOTO = `${BASE_URL}/import-shipment/loading-photos/get`;

export const CREATE_PRODUCT_PHOTO = `${BASE_URL}/import-shipment/product-photos/create`;
export const LIST_PRODUCT_PHOTO = `${BASE_URL}/import-shipment/product-photos/get`;

// duty and tax
export const LIST_DUTIES = `${BASE_URL}/import-shipment/duty/get`;
export const CREATE_DUTY = `${BASE_URL}/import-shipment/duty/create`;
export const READ_DUTY = (dutyId) => `${BASE_URL}/import-shipment/duty/${dutyId}`;
export const UPDATE_DUTY = (dutyId) => `${BASE_URL}/import-shipment/duty/${dutyId}`;
export const DELETE_DUTY = (dutyId) => `${BASE_URL}/import-shipment/duty/${dutyId}`;
export const DELETE_DUTY_PARTICULAR = (dutyParticularId) => `${BASE_URL}/import-shipment/duty-particular/${dutyParticularId}`;

// Export Proforma Invoices
export const LIST_PROFORMA_INVOICES_EXPORT = `${BASE_URL}/export-shipment/proforma-invoice/get`;
export const CREATE_PROFORMA_INVOICE_EXPORT = `${BASE_URL}/export-shipment/proforma-invoice/create`;
export const READ_PROFORMA_INVOICE_EXPORT = (proformaInvExpId) => `${BASE_URL}/export-shipment/proforma-invoice/${proformaInvExpId}`;
export const UPDATE_PROFORMA_INVOICE_EXPORT = (proformaInvExpId) => `${BASE_URL}/export-shipment/proforma-invoice/${proformaInvExpId}`;
export const DELETE_PROFORMA_INVOICE_EXPORT = (proformaInvExpId) => `${BASE_URL}/export-shipment/proforma-invoice/${proformaInvExpId}`;
export const DELETE_PROFORMA_INVOICE_PARTICULAR_EXPORT = (proformaParticularsExpId) => `${BASE_URL}/export-shipment/proforma-invoice-particular/${proformaParticularsExpId}`;


// Export Sales Contracts
export const LIST_SALES_CONTRACTS_EXPORT = `${BASE_URL}/export-shipment/sales-contract/get`;
export const CREATE_SALES_CONTRACT_EXPORT = `${BASE_URL}/export-shipment/sales-contract/create`;
export const READ_SALES_CONTRACT_EXPORT = (salesContractId) => `${BASE_URL}/export-shipment/sales-contract/${salesContractId}`;
export const UPDATE_SALES_CONTRACT_EXPORT = (salesContractId) => `${BASE_URL}/export-shipment/sales-contract/${salesContractId}`;
export const DELETE_SALES_CONTRACT_EXPORT = (salesContractId) => `${BASE_URL}/export-shipment/sales-contract/${salesContractId}`;
export const DELETE_SALES_CONTRACT_PARTICULAR_EXPORT = (salesContractParticularsId) => `${BASE_URL}/export-shipment/sales-contract-particular/${salesContractParticularsId}`;

// Export Commercial Invoices
export const LIST_COMMERCIAL_INVOICES_EXPORT = `${BASE_URL}/export-shipment/commercial-invoice/get`;
export const CREATE_COMMERCIAL_INVOICE_EXPORT = `${BASE_URL}/export-shipment/commercial-invoice/create`;
export const READ_COMMERCIAL_INVOICE_EXPORT = (commercialInvExpId) => `${BASE_URL}/export-shipment/commercial-invoice/${commercialInvExpId}`;
export const UPDATE_COMMERCIAL_INVOICE_EXPORT = (commercialInvExpId) => `${BASE_URL}/export-shipment/commercial-invoice/${commercialInvExpId}`;
export const DELETE_COMMERCIAL_INVOICE_EXPORT = (commercialInvExpId) => `${BASE_URL}/export-shipment/commercial-invoice/${commercialInvExpId}`;
export const DELETE_COMMERCIAL_INVOICE_PARTICULAR_EXPORT = (commercialParticularsExpId) => `${BASE_URL}/export-shipment/commercial-invoice-particular/${commercialParticularsExpId}`;

// Export Receipt Vouchers
export const LIST_RECEIPT_VOUCHERS_EXPORT = `${BASE_URL}/export-shipment/receipt-voucher/get`;
export const CREATE_RECEIPT_VOUCHER_EXPORT = `${BASE_URL}/export-shipment/receipt-voucher/create`;
export const READ_RECEIPT_VOUCHER_EXPORT = (receiptVoucherId) => `${BASE_URL}/export-shipment/receipt-voucher/${receiptVoucherId}`;
export const UPDATE_RECEIPT_VOUCHER_EXPORT = (receiptVoucherId) => `${BASE_URL}/export-shipment/receipt-voucher/${receiptVoucherId}`;
export const DELETE_RECEIPT_VOUCHER_EXPORT = (receiptVoucherId) => `${BASE_URL}/export-shipment/receipt-voucher/${receiptVoucherId}`;
export const DELETE_RECEIPT_VOUCHER_EXPORT_PARTICULAR = (receiptVoucherParticularsId) => `${BASE_URL}/export-shipment/receipt-voucher-particular/${receiptVoucherParticularsId}`;


// Export BL Drafts
export const LIST_BL_DRAFTS_EXPORT = `${BASE_URL}/export-shipment/bl-draft/get`;
export const CREATE_BL_DRAFT_EXPORT = `${BASE_URL}/export-shipment/bl-draft/create`;
export const READ_BL_DRAFT_EXPORT = (blDraftId) => `${BASE_URL}/export-shipment/bl-draft/${blDraftId}`;
export const UPDATE_BL_DRAFT_EXPORT = (blDraftId) => `${BASE_URL}/export-shipment/bl-draft/${blDraftId}`;
export const DELETE_BL_DRAFT_EXPORT = (blDraftId) => `${BASE_URL}/export-shipment/bl-draft/${blDraftId}`;
export const DELETE_BL_DRAFT_PARTICULAR_EXPORT = (blDraftParticularsId) => `${BASE_URL}/export-shipment/bl-draft-particular/${blDraftParticularsId}`;

// Export COA
export const LIST_COAS_EXPORT = `${BASE_URL}/export-shipment/coa/get`;
export const CREATE_COA_EXPORT = `${BASE_URL}/export-shipment/coa/create`;
export const READ_COA_EXPORT = (coaId) => `${BASE_URL}/export-shipment/coa/${coaId}`;
export const UPDATE_COA_EXPORT = (coaId) => `${BASE_URL}/export-shipment/coa/${coaId}`;
export const DELETE_COA_EXPORT = (coaId) => `${BASE_URL}/export-shipment/coa/${coaId}`;
export const DELETE_COA_PARTICULAR_EXPORT = (coaParticularsId) => `${BASE_URL}/export-shipment/coa-particulars/${coaParticularsId}`;

// Export COO
export const LIST_COO_EXPORT = `${BASE_URL}/export-shipment/coo/get`;
export const CREATE_COO_EXPORT = `${BASE_URL}/export-shipment/coo/create`;
export const READ_COO_EXPORT = (cooId) => `${BASE_URL}/export-shipment/coo/${cooId}`;
export const UPDATE_COO_EXPORT = (cooId) => `${BASE_URL}/export-shipment/coo/${cooId}`;
export const DELETE_COO_EXPORT = (cooId) => `${BASE_URL}/export-shipment/coo/${cooId}`;

// Export Packing Lists
export const LIST_PACKING_LISTS_EXPORT = `${BASE_URL}/export-shipment/packing-list/get`;
export const CREATE_PACKING_LIST_EXPORT = `${BASE_URL}/export-shipment/packing-list/create`;
export const READ_PACKING_LIST_EXPORT = (packingListId) => `${BASE_URL}/export-shipment/packing-list/${packingListId}`;
export const UPDATE_PACKING_LIST_EXPORT = (packingListId) => `${BASE_URL}/export-shipment/packing-list/${packingListId}`;
export const DELETE_PACKING_LIST_EXPORT = (packingListId) => `${BASE_URL}/export-shipment/packing-list/${packingListId}`;


// Sales Order
export const LIST_SALES_ORDERS_EXPORT = `${BASE_URL}/export-shipment/sales-order/get`;
export const CREATE_SALES_ORDER_EXPORT = `${BASE_URL}/export-shipment/sales-order/create`;
export const READ_SALES_ORDER_EXPORT = (salesOrderId) => `${BASE_URL}/export-shipment/sales-order/${salesOrderId}`;
export const UPDATE_SALES_ORDER_EXPORT = (salesOrderId) => `${BASE_URL}/export-shipment/sales-order/${salesOrderId}`;
export const DELETE_SALES_ORDER_EXPORT = (salesOrderId) => `${BASE_URL}/export-shipment/sales-order/${salesOrderId}`;
export const DELETE_SALES_ORDER_PARTICULAR_EXPORT = (salesOrderParticularId) => `${BASE_URL}/export-shipment/sales-order-particular/${salesOrderParticularId}`;


// SUBSCRIPTION
export const CREATE_ORDER = `${BASE_URL}/subscription/create-order`;
export const SAVE_PAYMENT_INFO = `${BASE_URL}/subscription/save-payment-info`;
export const SAVE_ADDON_PAYMENT_INFO = `${BASE_URL}/subscription/save-addon-payment-info`;
export const SUBSCRIPTION_HISTORY = `${BASE_URL}/subscription/subscription-history`;
export const PAYMENT_LINK_CREATE_ORDER = `${BASE_URL}/subscription/payment-link/create-order`;
export const PAYMENT_LINK_SAVE_PAYMENT_INFO = `${BASE_URL}/subscription/payment-link/save-payment-info`;

// Reports
export const GET_IMPORT_SHIPMENT_REPORT = `${BASE_URL}/report/import-shipment`;
export const GET_EXPORT_SHIPMENT_REPORT = `${BASE_URL}/report/export-shipment`;
export const GET_EXPORT_PROFORM_REPORT = `${BASE_URL}/report/export-proforma-invoice`;
export const GET_SALES_CONTRACT_REPORT = `${BASE_URL}/report/sales-contract-report`;
export const GET_COMMERCIAL_INVOICE_REGISTER = `${BASE_URL}/report/commercial-invoice-register`;
export const GET_CUSTOMER_LEDGER = `${BASE_URL}/report/customer-ledger-report`;
export const GET_SUPPLIER_LEDGER = `${BASE_URL}/report/supplier-ledger-report`;
export const GET_IMPORT_BUDGET_PLANNING_REPORT = `${BASE_URL}/report/import-budget-planning-report`;
export const GET_EXPORT_BUDGET_PLANNING_REPORT = `${BASE_URL}/report/export-budget-planning-report`;


export const GET_CUSTOMER_PRODUCT = `${BASE_URL}/report/customer-product`;
export const GET_CUSTOMER_PRODUCT_MONTHLY = `${BASE_URL}/report/customer-product-monthly`;
export const GET_CUSTOMER_PRODUCT_MONTHLY_INVOICE = `${BASE_URL}/report/customer-product-monthly-invoice`;

export const GET_SUPPLIER_PRODUCT = `${BASE_URL}/report/supplier-product`;
export const GET_SUPPLIER_PRODUCT_MONTHLY = `${BASE_URL}/report/supplier-product-monthly`;
export const GET_SUPPLIER_PRODUCT_MONTHLY_INVOICE = `${BASE_URL}/report/supplier-product-monthly-invoice`;


export const READ_SUPPLIER_LEDGER = `${BASE_URL}/report/supplier-ledger-report-view`;

export const READ_CUSTOMER_LEDGER = `${BASE_URL}/report/customer-ledger-report-view`;

export const GET_IMPORT_PAYMENT_REPORT = `${BASE_URL}/report/import-payment-report`;
export const GET_EXPORT_PAYMENT_REPORT = `${BASE_URL}/report/export-payment-report`;
export const GET_IMPORT_SHIPMENT_BOOKING_REPORT = `${BASE_URL}/report/import-shipment-booking`;
export const GET_EXPORT_SHIPMENT_BOOKING_REPORT = `${BASE_URL}/report/export-shipment-booking`;

export const GET_FREE_DAYS_REPORT = `${BASE_URL}/report/free-days-report`;
export const GET_BATCH_WISE_IMP_SHIPMENT = `${BASE_URL}/report/batch-wise-imp-shipment`;
export const GET_EXPORT_PROFORMA_INVOICE = `${BASE_URL}/report/export-proforma-invoice`;
export const GET_BATCH_WISE_EXP_SHIPMENT = `${BASE_URL}/report/batch-wise-exp-shipment`;
export const GET_PAYMENT_REGISTER = `${BASE_URL}/report/payment-register`;
export const GET_RECEIPT_REGISTER = `${BASE_URL}/report/receipt-register`;
export const GET_IMPORT_SHIPMENT_TRACKING = `${BASE_URL}/report/import-shipment-tracking`;
export const GET_EXPORT_SHIPMENT_TRACKING = `${BASE_URL}/report/export-shipment-tracking`;
export const GET_PRODUCT_WISE_IMPORT = `${BASE_URL}/report/product-wise-import`;
export const GET_PRODUCT_WISE_IMPORT_MONTHLY = `${BASE_URL}/report/product-wise-import-monthly`;

export const GET_PRODUCT_WISE_EXPORT = `${BASE_URL}/report/product-wise-export`;
export const GET_PRODUCT_WISE_EXPORT_MONTHLY = `${BASE_URL}/report/product-wise-export-monthly`;


export const GET_IMPORT_SHIPMENT_COSTING = `${BASE_URL}/report/import-shipment-costing`;
export const READ_IMPORT_SHIPMENT_COSTING = `${BASE_URL}/report/import-shipment-costing-report-view`;
export const GET_EXPORT_SHIPMENT_COSTING = `${BASE_URL}/report/export-shipment-costing`;
export const READ_EXPORT_SHIPMENT_COSTING = `${BASE_URL}/report/export-shipment-costing-report-view`;
export const GET_IMPORT_SHIPMENT_DUE_DATE_REPORT = `${BASE_URL}/report/import-shipment-due-date`;
export const GET_EXPORT_SHIPMENT_DUE_DATE_REPORT = `${BASE_URL}/report/export-shipment-due-date`;

export const GET_EXPENSE_PARTY_LEDGER_REPORT = `${BASE_URL}/report/expense-party-ledger-report`;
export const GET_EXPENSE_PARTY_LEDGER_REPORT_VIEW = `${BASE_URL}/report/expense-party-ledger-view`;

// Import Product group APIs
export const GET_IMPORT_PRODUCT_GROUP_REPORT = `${BASE_URL}/report/import-product-group`;
export const GET_IMPORT_PRODUCT_GROUP_MONTHLY_REPORT = `${BASE_URL}/report/import-product-group-monthly`;

// ✅ Export Product  group APIs
export const GET_EXPORT_PRODUCT_GROUP_REPORT = `${BASE_URL}/report/export-product-group`;
export const GET_EXPORT_PRODUCT_GROUP_MONTHLY_REPORT = `${BASE_URL}/report/export-product-group-monthly`;


// top dashboard API
export const GET_DASHBOARD_LIST = `${BASE_URL}/dashboard/get`;
export const GET_DASHBOARD_TOP_IMPORT = `${BASE_URL}/dashboard/top-import`;
export const GET_DASHBOARD_TOP_EXPORT = `${BASE_URL}/dashboard/top-export`;
export const GET_DASHBOARD_TOP_PAYABLE = `${BASE_URL}/dashboard/top-payable`;
export const GET_DASHBOARD_TOP_RECEIVEABLE = `${BASE_URL}/dashboard/top-receiveable`;
export const GET_DASHBOARD_TOP_CONTAINERS = `${BASE_URL}/dashboard/top-containers`;
export const GET_DASHBOARD_TOP_PORT = `${BASE_URL}/dashboard/top-port`;

// role 

export const GET_ROLE = `${BASE_URL}/role/get`;
export const POST_ROLE = `${BASE_URL}/role/create`;
export const READ_ROLE = (roleId) => `${BASE_URL}/role/${roleId}`;
export const UPDATE_ROLE = (roleId) => `${BASE_URL}/role/${roleId}`;

// module 

export const GET_MODULE = `${BASE_URL}/module/get`;
export const POST_PERMISIONS = `${BASE_URL}/permissions/create`
export const GET_PERMISSIONS = `${BASE_URL}/permissions/get/by/profile`
export const UPDATE_PERMISSIONS = (profileId) => `${BASE_URL}/permissions/${profileId}`;


export const GET_PROFILE = `${BASE_URL}/profile/get`
export const CREATE_PROFILE = `${BASE_URL}/profile/create`
export const UPDATE_PROFILE = (profileId) => `${BASE_URL}/profile/${profileId}`;
export const READ_PROFILE = (profileId) => `${BASE_URL}/profile/${profileId}`;
export const DELETE_PROFILE = (profileId) => `${BASE_URL}/profile/${profileId}`;


// add users 

export const ADD_ORG_USERS = `${BASE_URL}/company-user/create`;
export const GET_ORG_USERS = `${BASE_URL}/company-user/list`;
export const GET_ORG_USERS_LIST = `${BASE_URL}/company-user/user-list`;
export const READ_ORG_USERS = (companyUserId) => `${BASE_URL}/company-user/${companyUserId}`;
export const UPDATE_ORG_USERS = (companyUserId) => `${BASE_URL}/company-user/${companyUserId}`;
export const DELETE_ORG_USERS = (companyUserId) => `${BASE_URL}/company-user/${companyUserId}`;


export const START_FREE_TRAIL = `${BASE_URL}/organization/create`
export const GET_ORGANIZATION_LIST = `${BASE_URL}/organization/get`

